import React, {createContext, useContext, useEffect, useState} from 'react';
import {useNavigate} from 'react-router-dom';
import Cookies from 'js-cookie';

const AuthContext = createContext(null);

export const AuthProvider = ({children}) => {
    const [user, setUser] = useState(null);
    const navigate = useNavigate();

    // Benutzer beim Start der App wiederherstellen
    useEffect(() => {
        const token = Cookies.get('accessToken');
        if (token) {
            setUser({token});
        }
    }, []);

    // Login-Funktion
    const login = (userData) => {
        console.log('Speichere Benutzerdaten im Context:', userData);
        Cookies.set('accessToken', userData.accessToken, {secure: true, sameSite: 'None', path: '/'}); // Access Token im Cookie speichern
        setUser(userData); // Benutzer im State speichern
        navigate('/dashboard'); // Zum Dashboard navigieren
    };

    // Logout-Funktion
    const logout = () => {
        Cookies.remove('accessToken', {path: '/'}); // Access Token aus den Cookies entfernen
        setUser(null);
        navigate('/login');
    };

    return (
        <AuthContext.Provider value={{user, login, logout}}>
            {children}
        </AuthContext.Provider>
    );
};

// Hook zur Verwendung des Auth-Contexts
export const useAuth = () => {
    const context = useContext(AuthContext);
    if (context === null) {
        throw new Error('useAuth muss innerhalb eines AuthProvider verwendet werden');
    }
    return context;
};


